/** Who the signed-in agency is, as the header says it: its name, and the location it is signed in to. */
export interface AgencyIdentity {
  readonly name: string;
  /** The agency location (its `locationAlias`), or null for an agency with one location and no alias. */
  readonly location: string | null;
}

/**
 * The agency's name and location from the signed-in account, as the console's main header wrote them together
 * ("Name - Location"). Null where the account has no name yet.
 */
export function agencyIdentity(
  account: Readonly<{ name?: string | null; locationAlias?: string | null }>
): AgencyIdentity | null {
  const name = account.name?.trim();
  if (!name) {
    return null;
  }
  return { name, location: account.locationAlias?.trim() || null };
}
